/** @format */

import './assets/main.css'
import './assets/css/root.css'
import './assets/css/vant.scss'
import './assets/css/animate.scss'
import './assets/css/position.scss'
import './assets/css/flex.scss'
import './assets/css/box.scss'
import './assets/css/text.scss'
import './assets/css/common.scss'
import 'vant/lib/index.css'
import { user } from './state/user'
import { env } from './state/env'
import { getCookie } from './utils/browser'
import { i18n } from '@/locales'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { registerComponent, registerDirective } from './register'
import { registerUiComponents } from './ui-runtime/core/ui-components'
import client from './utils/client'
import { Native } from './core/native'
import { routes } from './routers'
import thinkingdata from 'thinkingdata-browser'
import { nextTick } from 'vue'
import { createPinia } from 'pinia'
import { useStores } from '@/stores'
import { VueQueryPlugin } from '@tanstack/vue-query'
import CryptoJS from 'crypto-js'
import { DialogPlugin } from './ui-runtime/core/components/interaction/dialog/index'
import { ToastPlugin } from './ui-runtime/core/components/lib/toast/index'
import { setActivityConfig } from './utils/bff_enter'

// 检测是否为移动设备
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

const app = createApp({})
registerComponent(app)
registerDirective(app)
registerUiComponents(app)

app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        // 失败后最多重试 3 次，不再无限重试
        retry: 3,
      },
      mutations: {
        retry: 0,
      },
    },
  },
})
app.use(DialogPlugin)
app.use(ToastPlugin)

// app.use(ElementPlus);

const router = createRouter({
  // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
  history: createWebHistory(),
  routes, // `routes: routes` 的缩写
})

router.beforeEach(async (to, from, next) => {
  await setActivityConfig(to)
  next()
})

// ThinkingData 页面跟踪
router.afterEach((to, from) => {
  nextTick(() => {
    thinkingdata.autoTrackSinglePage()
  })
})

const pinia = createPinia()

app.use(router)
app.use(i18n)
app.use(pinia)
app.mount('#app')
let domain = window.location.host
let urlParams = new URLSearchParams(window.location.search.slice(1))
if (urlParams.get('release') === 'true') {
  env.domain = 'https://api.hifunclub.com'
  env.debug = false
} else {
  if (
    domain.startsWith('localhost') ||
    domain.startsWith('127.0.0.1') ||
    domain.startsWith('192.168.') ||
    domain.startsWith('dev')
  ) {
    env.domain = import.meta.env.VITE_API_DOMAIN || 'https://dev-api.hifunclub.com'
    // env.domain = "http://127.0.0.1:8000"
    env.debug = true
    import('vconsole').then(({ default: VConsole }) => {
      if (isMobile && location.pathname !== '/h5/iframe') {
        new VConsole()
      }
    })
  } else {
    env.domain = 'https://api.hifunclub.com'
    env.debug = false
  }
}
let shushu_app_id = ''
let showLog = false
if (env.debug) {
  shushu_app_id = 'debug-appid'
  showLog = true
} else {
  shushu_app_id = '2019405f49e64c75a0a1604880afb944'
}

try {
  user.access_token = urlParams.get('access_token') || getCookie('Access-Token')
  console.log('main.js->access_token: ' + user.access_token)
  localStorage.setItem('token', user.access_token)
} catch (error) {
  console.error('main.js->error: ' + error)
}
client.callNative(Native.VERSION, {}, data => {
  let clientVersion = data.data || ''
  env.version = clientVersion
})
client.callNative(Native.PLATFORM, {}, data => {
  let clientPlatform = data.data || ''
  env.platform = clientPlatform
})
client.callNative(Native.STATUS_BAR, {}, data => {
  env.statusBarHeight = data.data || 30
})
env.language = i18n.global.locale.value.toString()
if (urlParams.get('app-language')) {
  env.language = urlParams.get('app-language')
}

// ThinkingData 配置
const tdConfig = {
  appId: shushu_app_id, // 替换为实际的 APP_ID
  serverUrl: 'https://ta-receiver.hifunclub.com', // 替换为实际的服务器地址
  batch: false,
  showLog: showLog,
  autoTrack: {
    pageShow: false,
    pageHide: false,
  },
}

thinkingdata.init(tdConfig)

window.ta = thinkingdata

const { setUserInfo } = useStores()

loadSelfInfo(function (data) {
  user.nickname = data.nickname
  user.is_high_quality = data.is_high_quality
  setUserInfo(data)
  window.ta.login(data.userid)
})

const allUrlParams = new URLSearchParams(window.location.search)
const publicId = allUrlParams.get('public_id')
const deviceId = allUrlParams.get('device_id')
trackEvent(null, 'web_homepage_exposure', {
  ...(publicId && { app_user_id: publicId }),
  ...(deviceId && { app_device_id: deviceId }),
  current_url: window.location.href,
  title: document.title,
})

if (!localStorage.getItem('device_id')) {
  localStorage.setItem('device_id', CryptoJS.MD5(navigator.userAgent).toString() + '-' + new Date().getTime())
}
